exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download_file-name_1ae0K {\r\n    font-family: monospace;\r\n    -webkit-user-select: text;\r\n       -moz-user-select: text;\r\n        -ms-user-select: text;\r\n            user-select: text;\r\n    word-wrap: break-word;\r\n}\r\n.download_file-name_1ae0K::before {\r\n    content: '\"';\r\n}\r\n.download_file-name_1ae0K::after {\r\n    content: '\"';\r\n}\r\n.download_name_1dXN3 {\r\n\r\n}\r\n.download_dot_1GvC1 {\r\n\r\n}\r\n.download_extension_15MbY {\r\n    text-decoration: underline;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"file-name": "download_file-name_1ae0K",
	"fileName": "download_file-name_1ae0K",
	"name": "download_name_1dXN3",
	"dot": "download_dot_1GvC1",
	"extension": "download_extension_15MbY"
};